import {cn} from '@/lib/utils'
import {Button} from '@/components/ui/button'
import {Card, CardContent} from '@/components/ui/card'
import {Field, FieldGroup, FieldLabel} from '@/components/ui/field'
import {Alert, AlertDescription, AlertTitle} from '@/components/ui/alert'
import {Input} from '@/components/ui/input'
import {CircleXIcon} from 'lucide-react'
import {useEffect, useState, type SubmitEvent} from 'react'
import {useAuth} from '@/hooks/auth-provider'
import {navigate} from 'wouter/use-browser-location'

export function LoginForm({className, ...props}: React.ComponentProps<'div'>) {
  const auth = useAuth()

  useEffect(() => {
    if (auth.user) navigate('/')
  })

  const [_loading, setLoading] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')

  const handleSubmit = (event: SubmitEvent) => {
    event.preventDefault()

    setMessage('')
    setLoading(true)

    const username = event.target!.username.value
    const password = event.target!.password.value

    auth.logIn(username, password).then(
      () => navigate('/'),
      error => {
        const resMessage = error.response?.error || error.message || error.toString()

        setLoading(false)
        setMessage(resMessage)
      },
    )
  }

  return (
    <div className={cn('mx-auto min-h-screen max-w-sm flex flex-col place-content-center gap-6', className)} {...props}>
      <Card>
        <CardContent>
          <form onSubmit={handleSubmit}>
            <FieldGroup>
              <Field>
                <FieldLabel htmlFor='username'>Username</FieldLabel>
                <Input id='username' type='text' required />
              </Field>
              <Field>
                <FieldLabel htmlFor='password'>Password</FieldLabel>
                <Input id='password' type='password' required />
              </Field>
              <Field>
                <Button type='submit'>Sign in</Button>
                {/* <Button variant="outline" type="button">
                  Login with KeyCloak
                </Button>
                <FieldDescription className="text-center">
                  Don&apos;t have an account? <a href="#">Sign up</a>
                </FieldDescription> */}
              </Field>
            </FieldGroup>
          </form>
        </CardContent>
      </Card>
      {message && (
        <Alert>
          <CircleXIcon />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{message}</AlertDescription>
          {/* <AlertAction>
          <Button onClick={() => setMessage('')} variant="outline">Close</Button>
        </AlertAction> */}
        </Alert>
      )}
    </div>
  )
}
